import { HeaderCell } from 'pages/Financial/Dre/styles'

// A primeira coluna é estreita: os nomes compridos quebram de linha em vez de ficarem cortados com reticências.
export const WRAP_STYLE = { whiteSpace: 'normal', overflowWrap: 'anywhere' }

const DAY_STYLE = { fontWeight: 400, fontSize: 12, color: '#666666' }

/*
  O cabeçalho das tabelas de metas: o dia da semana ("Seg") e, embaixo dele na mesma célula, o dia do
  mês ("Dia 01"), como as duas linhas da planilha. É uma linha só de propósito: o cabeçalho gruda no
  topo ao rolar, e duas linhas com `position: sticky; top: 0` se sobrepõem. O título quebra de linha
  quando não cabe na primeira coluna.
*/
export default function GoalsHeader({ title, columns, trailing = ['Total'] }) {
  return (
    <thead>
      <tr>
        <HeaderCell sticky align='left' style={WRAP_STYLE}>{title}</HeaderCell>
        {columns.map(column => (
          <HeaderCell key={column.date}>
            <div>{column.weekdayLabel}</div>
            <div style={DAY_STYLE}>{column.dayLabel}</div>
          </HeaderCell>
        ))}
        {trailing.map(label => <HeaderCell key={label}>{label}</HeaderCell>)}
      </tr>
    </thead>
  )
}
